import { BotFeatures, QueryListFilter } from '@feedyou-ai/feedbot-schema'

import { useBotId } from '../../store/flow'
import { useOpenBotId } from '../../store/app'
import { TableContinuationToken } from './types'
import { knowledgeBaseApi } from './knowledgeBaseApi'
import { useFeature } from '../../store/features'

export const useKnowledgeBaseQuery = ({
  modelId,
  queryFilter,
  continuationToken
}: {
  modelId: string
  queryFilter: QueryListFilter
  continuationToken?: TableContinuationToken
}) => {
  const botId = useOpenBotId()!

  return knowledgeBaseApi.endpoints.getKnowledgeBaseQuery.useQuery({
    botId,
    modelId,
    queryFilter,
    continuationToken
  })
}

export const useKnowledgeBaseDocuments = (modelId: string) => {
  const botId = useBotId()

  return knowledgeBaseApi.endpoints.getKnowledgeBaseDocuments.useQuery({ botId, modelId })
}

export const useKnowledgeBasePaths = (modelId: string) => {
  const botId = useBotId()

  return knowledgeBaseApi.endpoints.getKnowledgeBasePaths.useQuery({ botId, modelId })
}

export const useKnowledgeBaseDocumentChunks = (modelId: string, documentId: string) => {
  const botId = useBotId()

  return knowledgeBaseApi.endpoints.getKnowledgeBaseDocumentChunks.useQuery({
    botId,
    modelId,
    documentId
  })
}

export const useAddDocumentMutation = () => {
  return knowledgeBaseApi.endpoints.addKnowledgeBaseDocument.useMutation()
}

export const usePutDocumentSettingsMutation = () => {
  return knowledgeBaseApi.endpoints.putKnowledgeBaseDocumentSettings.useMutation()
}

export const usePutPathSettingsMutation = () => {
  return knowledgeBaseApi.endpoints.putKnowledgeBasePathSettings.useMutation()
}

export const useDeleteDocumentMutation = () => {
  return knowledgeBaseApi.endpoints.deleteKnowledgeBaseDocument.useMutation()
}

export const useDeletePathMutation = () => {
  return knowledgeBaseApi.endpoints.deleteKnowledgeBasePath.useMutation()
}

export function useIsStandaloneKbEnabled() {
  const dgFlag = !!useFeature('STANDALONE_KNOWLEDGE_BASE')
  const botFlag = !!useFeature(BotFeatures.STANDALONE_KNOWLEDGE_BASE)

  return dgFlag && botFlag
}
